import base from './base';

export default {
  getThreads(orderId) {
    return base.get(`orders/${orderId}/threads`);
  },

  replyThread(orderId, text) {
    return base.postFormData(`orders/${orderId}/threads`, { text });
  },

  activatePin(orderId, pinId) {
    return base.postFormData(`orders/${orderId}/activate_pin`, { "id": pinId });
  },

  sharePin(pinId) {
    return base.post(`pins/${pinId}/share`);
  },

  unsharePin(pinId) {
    return base.post(`pins/${pinId}/unshare`);
  },
}
